import { EmptyState, Button } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  onResetFilters: () => void;
};

export const PayableTableEmptyResult = ({ onResetFilters }: Props) => {
  const { t } = useTranslation('global');

  return (
    <EmptyState
      className="my-24 flex flex-col items-center justify-center"
      title={t('payables.filterEmptyResult.title')}
      subtitle={t('payables.filterEmptyResult.subtitle')}
      iconName="magnifying-glass"
      iconVariant="purple"
      actions={[
        <Button
          key="cta"
          variant="primaryBrand"
          onClick={onResetFilters}
          text={t('payables.filterEmptyResult.cta')}
        />,
      ]}
    />
  );
};
